var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_c('router-link',{attrs:{"to":{'name':'home'}}},[_vm._v("HOME")])],1),_c('p',{staticClass:"copyright"},[_vm._v("©2021 Sabian Symbols Images rights reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }